import React from "react";
import Select from "react-select";
import {Result} from "../../types/Result";
import {sweetalert} from "../../App";
import {isBlank, isOnlyWhitespace} from "../../util/ValidationUtil";
import {buildRow, getBoolSelectOptions, getBoolSelectOptionsWithInts, getBoolSelectVal, getBoolSelectValWithInts, getLabel} from "../../util/FormatUtil";
import {get, isEmptyObject} from "jquery";
import GetField from "../../customfields/GetField";
import { CustomFieldBuilder } from "../../customfields/CustomFieldBuilder";
import { Kit } from "../../types/Kit";

interface KitInventoryManagementModalState{
    selectedKit:Kit
}
interface KitInventoryManagementModalProps{
    selectedKit
    services
    onSubmit?
}
export class KitInventoryManagementModal extends React.Component<KitInventoryManagementModalProps, KitInventoryManagementModalState>{
    public static ID = "kitinventorymanagement";
    constructor(props) {
        super(props);
        this.state = {
            selectedKit: {
                ID: null,
                SpecimenID: null,
                KitID: null,
                ServiceID: null,
                ReturnLabel: "",
                RegistrationDate: null,
                ShippingLabel: "",
                ShopifyOrder: "",
                ReturnShippingLabelNumber: "",
                OutboundShippingLabelNumber: "",
                OrderNumber: "",
                FulfillmentDate: null,
            } as Kit
        } as KitInventoryManagementModalState
        
    }

    componentWillReceiveProps(nextProps: Readonly<KitInventoryManagementModalProps>, nextContext: any) {
        // console.log('KitInventoryManagementModal componentWillReceiveProps nextProps', nextProps)
        if(!isEmptyObject(nextProps.selectedKit)){
            let result = nextProps.selectedKit;
            this.setState({
                selectedKit: {
                    ID: result.ID,
                    SpecimenID: result.SpecimenID,
                    KitID: result.KitID,
                    ServiceID: result.ServiceID,
                    ReturnLabel: result.ReturnLabel,
                    RegistrationDate: result.RegistrationDate,
                    ShippingLabel: result.ShippingLabel,
                    ShopifyOrder: result.ShopifyOrder,
                    ReturnShippingLabelNumber: result.ReturnShippingLabelNumber,
                    OutboundShippingLabelNumber: result.OutboundShippingLabelNumber,
                    OrderNumber: result.OrderNumber,
                    FulfillmentDate: result.FulfillmentDate,
                } as Kit
            });
       
        }
    }

    render(){
        // console.log('KitInventoryManagementModal render STATE', this.state)
        return(
            <div className="modal fade form_modal" id={KitInventoryManagementModal.ID} tabIndex={-1} role="dialog"
                 aria-labelledby="result_modal_label"
                 aria-hidden="true">
                <div className="modal-dialog modal-lg modal-xl" role="document">
                    <div className="modal-content">
                    <div className="container-fluid">
                        <div className="modal-header">
                            <h5 className="modal-title" id="result_modal_label">Kit Management</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {buildRow("Service",
                                <Select
                                isSearchable={true}
                                placeholder={"Please Select..."}
                                noOptionsMessage={() => "No option"}
                                aria-label="Service"
                                value={getLabel(this.state.selectedKit.ServiceID, this.props.services.map(k => ({label: k.Name, value: k.ID})))}
                                onChange={(e) => this.setState((prevState)=>({
                                    selectedKit: {
                                        ...prevState.selectedKit,
                                        ServiceID: e.value,
                                    }
                                }))}
                                className={"state_select"}
                                options={this.props.services.map(k => ({label: k.Name, value: k.ID}))}
                            />
                            )}
                            {buildRow("Kit ID",
                                <input className={"form-control"}
                                       id="KitID"
                                       maxLength={50}
                                       autoComplete={"off"}
                                       type={"search"}
                                       name={"KitID"}
                                       aria-label="KitID"
                                       readOnly={!!this.state.selectedKit.RegistrationDate}
                                       onChange={(e)=>{
                                           this.setState( (prevState) => ({
                                               selectedKit: {
                                                   ...prevState.selectedKit,
                                                   KitID: e.target.value
                                               }
                                           }))
                                       }}
                                       value={this.state.selectedKit.KitID || ''}
                                />
                            )}
                            {buildRow("Specimen ID",
                                <input className={"form-control"}
                                       id="SpecimenID"
                                       maxLength={50}
                                       autoComplete={"off"}
                                       type={"search"}
                                       name={"SpecimenID"}
                                       aria-label="SpecimenID"
                                       readOnly={!!this.state.selectedKit.RegistrationDate}
                                       onChange={(e)=>{
                                           this.setState( (prevState) => ({
                                               selectedKit: {
                                                   ...prevState.selectedKit,
                                                   SpecimenID: e.target.value
                                               }
                                           }))
                                       }}
                                       value={this.state.selectedKit.SpecimenID || ''}
                                />
                            )}
                            {buildRow("Return Shipping Label",
                                <input className={"form-control"}
                                       id="ReturnShippingLabelNumber"
                                       maxLength={50}
                                       autoComplete={"off"}
                                       type={"search"}
                                       name={"Return Shipping Label"}
                                       aria-label="Return Shipping Label"
                                    //    readOnly={!!this.state.selectedKit.RegistrationDate}
                                       onChange={(e)=>{
                                           this.setState( (prevState) => ({
                                               selectedKit: {
                                                   ...prevState.selectedKit,
                                                   ReturnShippingLabelNumber: e.target.value
                                               }
                                           }))
                                       }}
                                       value={this.state.selectedKit.ReturnShippingLabelNumber || ''}
                                />
                            )}
                            {buildRow("Outbound Shipping Label",
                                <input className={"form-control"}
                                       id="OutboundShippingLabelNumber"
                                       maxLength={50}
                                       autoComplete={"off"}
                                       type={"search"}
                                       name={"Outbound Shipping Label"}
                                       aria-label="Outbound Shipping Label"
                                    //    readOnly={!!this.state.selectedKit.RegistrationDate}
                                       onChange={(e)=>{
                                           this.setState( (prevState) => ({
                                               selectedKit: {
                                                   ...prevState.selectedKit,
                                                   OutboundShippingLabelNumber: e.target.value
                                               }
                                           }))
                                       }}
                                       value={this.state.selectedKit.OutboundShippingLabelNumber || ''}
                                />
                            )}
                            {buildRow("Order Number",
                                <input className={"form-control"}
                                       id="OrderNumber"
                                       maxLength={50}
                                       autoComplete={"off"}
                                       type={"search"}
                                       name={"Order Number"}
                                       aria-label="Order Number"
                                    //    readOnly={!!this.state.selectedKit.RegistrationDate}
                                       onChange={(e)=>{
                                           this.setState( (prevState) => ({
                                               selectedKit: {
                                                   ...prevState.selectedKit,
                                                   OrderNumber: e.target.value
                                               }
                                           }))
                                       }}
                                       value={this.state.selectedKit.OrderNumber || ''}
                                />
                            )}
                            {buildRow("Registration Date",
                            <input
                                className={"form-control"}
                                autoComplete={"off"}
                                type={"date"}
                                name={"RegistrationDate"}
                                value={this.state.selectedKit.RegistrationDate && !isNaN(new Date(this.state.selectedKit.RegistrationDate).getTime()) ? new Date(this.state.selectedKit.RegistrationDate).toISOString().split('T')[0] : ''}
                                onChange={(e) => {
                                    this.setState({
                                        selectedKit: {
                                            ...this.state.selectedKit,
                                            RegistrationDate: e.target.value ? new Date(e.target.value) : null
                                        }
                                    })
                                }}
                            />
                        )}
                        {buildRow("Fulfillment Date",
                            <input
                                className={"form-control"}
                                autoComplete={"off"}
                                type={"date"}
                                name={"FulfillmentDate"}
                                value={this.state.selectedKit.FulfillmentDate && !isNaN(new Date(this.state.selectedKit.FulfillmentDate).getTime()) ? new Date(this.state.selectedKit.FulfillmentDate).toISOString().split('T')[0] : ''}
                                onChange={(e) => {
                                    this.setState({
                                        selectedKit: {
                                            ...this.state.selectedKit,
                                            FulfillmentDate: e.target.value ? new Date(e.target.value) : null
                                        }
                                    })
                                }}
                            />
                        )}
                            
                           
                            
                            
                           

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" onClick={() => {
                                if(isBlank(this.state.selectedKit.SpecimenID) ||
                                    isOnlyWhitespace(this.state.selectedKit.SpecimenID)
                                ){
                                    return sweetalert.fire("","Specimen ID cannot be empty.", "error")
                                }
                                if(isBlank(this.state.selectedKit.KitID) ||
                                    isOnlyWhitespace(this.state.selectedKit.KitID)
                                ){
                                    return sweetalert.fire("","Kit ID cannot be empty.", "error")
                                }
                                if( this.state.selectedKit.ServiceID === null && this.state.selectedKit.ID === null ){
                                    return sweetalert.fire("", "Please select a value for Service", "error")
                                } 
                              
                                this.props.onSubmit(this.state.selectedKit);
                            }}>
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        )
    }
}